import { Component, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { NewTripsService } from 'app/dashboard/new-trips/new-trips.service';
import { OrderFrontEndStateEnum } from 'app/dashboard/post-dispatch/post-dispatch.interfaces';
import { OrderStateEnum, OrderSummary } from 'app/operations-tracking/operations-tracking.interface';
import { OperationsTrackingService } from 'app/operations-tracking/operations-tracking.service';
import { NotificationsService } from 'app/shared/notifications/notifications.service';
import { Subscription, combineLatest } from 'rxjs';
import { OrderTrackingComponent } from '../order-tracking/order-tracking.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-final-failed',
  templateUrl: './final-failed.component.html',
  styleUrls: ['./final-failed.component.scss']
})
export class FinalFailedComponent  extends OrderTrackingComponent implements OnDestroy {
  finalFailedSubscription: Subscription;
  dataSource = new MatTableDataSource<OrderSummary>([]);
  OrderStateEnum = OrderStateEnum;
  displayedColumns = this.isAdmin ? ['Split' ,'BusinessName', 'CustomerReference','WarehouseName','ScheduledDate','LastEventName', 'Timestamp', 'LotteryRestartCount', 'IsRoundTrip', 'FleetAllocation', 'AssignedTo','Parcels','FailedParcels' , 'Actions'] :         this.displayedColumns = ['Split', 'CustomerReference','WarehouseName','ScheduledDate','LastEventName', 'Timestamp', 'LotteryRestartCount', 'IsRoundTrip', 'FleetAllocation', 'AssignedTo','Parcels', 'FailedParcels' ,'Actions']


  constructor(
    public newTripsService: NewTripsService,
    public notificationsService: NotificationsService,
    public operationsTrackingService: OperationsTrackingService,
    public store: Store
  ) {
    super(notificationsService, operationsTrackingService, store, newTripsService);
    this.operationsTrackingService.usedIds$.pipe(takeUntil(this.unsubscribe$)).subscribe((ids: string[]) => {
      this.selectedIds = ids;
      this.getFinalFailedOrders();
    });
  }

  ngOnDestroy(): void {
    this.finalFailedSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getFinalFailedOrders(): void {
    const batches = this.getFirestoreBatchesForOrders(OrderFrontEndStateEnum.CompletedAllFailedFinalCollection)
    this.finalFailedSubscription?.unsubscribe();
    this.finalFailedSubscription = combineLatest(batches).subscribe((ordersSummary: OrderSummary[][]) => {
      let orders: OrderSummary[] = [];
      orders = orders.concat(...ordersSummary);
      this.dataSource.data = orders;
    });
  }
}
